import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';

import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './assets/scss/material-kit-react.scss?v=1.8.00';
import 'font-awesome/css/font-awesome.min.css';
import ReactGA from "react-ga4";
import CssBaseline from "@mui/material/CssBaseline";
import {
    ThemeProvider,
    createTheme,    
    StyledEngineProvider
} from "@mui/material/styles";

ReactGA.initialize("G-BYCJFNY1TQ");
ReactGA.send("pageview");

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

const theme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: "0.8rem"
          }
        }
      }
    }
  });
  
ReactDOM.render(
    <Provider store={store}>
        <HistoryRouter history={history}>
            <ThemeProvider theme={theme}>
            <CssBaseline />
                <StyledEngineProvider injectFirst>
                    <App />
                </StyledEngineProvider>
            </ThemeProvider>
        </HistoryRouter>
    </Provider>,
    rootElement);

registerServiceWorker();
